<template>
  <el-table :data="calendarsView" border>
    <el-table-column
        prop="name"
        label="カレンダ名"
        width="200"
        fixed="left">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="row.name">
            <template #prepend>
              <v-icon>mdi-calendar</v-icon>
            </template>
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        label="説明"
        min-width="150">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="row.description"
              placeholder="未設定"
              multi-line>
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        label="サマリ"
        min-width="200">
      <template #default="{row}">
        <error-popover :errors="row.errors"></error-popover>
        {{ row.summary }}
      </template>
    </el-table-column>

    <el-table-column
        width="95"
        align="right"
        fixed="right">
      <template #default="{row}">
        <icon-btns>
          <!-- 編集モード -->
          <template v-if="isEditable">
            <icon-btn
                type="delete"
                @click="openDeleteDialog(row)">
            </icon-btn>
            <icon-btn
                type="edit-content"
                @click="openUpdateDialog(row)">
            </icon-btn>
          </template>
        </icon-btns>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import Formatter from "@/utils/Formatter";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import {createCalendarView} from "@/components/pages/implementation/TerminalImplementationList/CalendarView";
import ErrorPopover from "@/components/molecules/ErrorPopover.vue";

export default {
  name: 'CalendarTable',
  mixins: [
    PathInfoMixin,
    Formatter
  ],
  components: {
    ErrorPopover,
    IconBtn,
    IconBtns,
    TextFieldLike,
    TableInline
  },
  props: {
    calendars: {
      type: Array,
      required: true
    }
  },
  computed: {
    calendarsView() {
      return this.calendars.map(cal => createCalendarView(cal));
    }
  },
  methods: {
    openDeleteDialog(row) {
      this.$emit('openDeleteDialog', row.source)
    },
    openUpdateDialog(row) {
      this.$emit('openUpdateDialog', row.source)
    },
  }
}
</script>
